import React, {useState,useCallback} from 'react'
import { useSelector } from 'react-redux'
import {selectUser} from '../features/userSlice'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import Parse from 'parse/dist/parse.min.js';
import {useDropzone} from 'react-dropzone'

export default function AddBusiness() {
    const user = useSelector(selectUser)
    const [loading, setLoading] = useState(false)
    const [fileImages, setFileImages] = useState([])

    const formik = useFormik({
      initialValues: {
        businessname:'',
        generalcategory:'Gastronomía',
        generalsubcategory:'Restaurantes',
        latitude:'',
        longitude:'',
        phone:'',
        clima:'',
        parking:'',
        delivery:'',
        description:'',
        metadata:'',        
      },
      validationSchema: Yup.object({
        businessname: Yup.string(),
        generalcategory: Yup.string(),
        generalsubcategory: Yup.string(),
        latitude: Yup.string(),
        longitude: Yup.string(),   
        delivery: Yup.string(),
        description: Yup.string(),
        metadata: Yup.string(),
      }),
      onSubmit: async (data) => {
        setLoading(true)
        console.log(data)        
      }
  })


  const onDrop = useCallback(acceptedFiles => {
   console.log(acceptedFiles)
  }, [])

  const {getRootProps:getRootPropsImages, getInputProps:getInputPropsImages} = useDropzone({
    accept: 'image/jpeg,image/png',
    maxFiles:10,
    noKeyboard:true,
    onDrop
  })



    if(!user) {
        return(
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
             <div className="sm:text-center ">
               <h1 className="text-6xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-8xl">
                 <span className="block xl:inline">:( ¡Opp! Área Restringida</span>{' '}
                 <span className="block text-cyan-600 xl:inline">Solo para usuarios Budgie</span>
               </h1>           
           
             </div>
           </main>
   
     </div> 
        )
    }


  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8  mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
   
    <div>
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900">Nuevo Negocio</h3>
              <p className="mt-1 text-sm text-gray-600">
              Esta información se mostrará públicamente.
              </p>
            </div>
          </div>
          <div className="mt-5 md:mt-0 md:col-span-2">
            <form action="#" method="POST" onSubmit={formik.handleSubmit}>
              <div className="shadow sm:rounded-md sm:overflow-hidden">
                <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="businessname" className="block text-sm font-medium text-gray-700">
                        Nombre del Negocio
                      </label>
                      <input
                        type="text"
                        name="businessname"                        
                        id="businessname"
                        value={formik.values.businessname}
                        onChange={formik.handleChange}
                        autoComplete="given-name"
                        className="mt-1 focus:ring-cyan-500 focus:border-cyan-500 block border w-full h-8 p-4 shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="generalcategory" className="block text-sm font-medium text-gray-700">
                        Categorías
                      </label>
                      <select
                        id="generalcategory"
                        name="generalcategory"
                        value={formik.values.generalcategory}
                        onChange={formik.handleChange}
                        autoComplete="generalcategory-name"
                        className="mt-1  block w-full py-2 px-3 border border-gray-400 bg-white rounded-md shadow-sm focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm"
                      >
                        <option>Gastronomía</option>                     
                      </select>
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="generalsubcategory" className="block text-sm font-medium text-gray-700">
                        Subcategorías
                      </label>
                      <select
                        id="generalsubcategory"
                        name="generalsubcategory"
                        value={formik.values.generalsubcategory}
                        onChange={formik.handleChange}
                        autoComplete="generalsubcategory-name"
                        className="mt-1  block w-full py-2 px-3 border border-gray-400 bg-white rounded-md shadow-sm focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm"
                      >
                        <option>Restaurantes</option>
                        <option>Hamburgueserías</option>
                        <option>Pizzerías</option>
                        <option>Heladerías</option>
                        <option>Cafeterías</option>
                        <option>Panaderías</option>
                        <option>Charcuterías</option>
                        <option>Mexicanas</option>
                        <option>Japonesa</option>
                        <option>Gourmet</option>
                        <option>Jugos</option>
                        <option>Pre Elaborado</option>
                        <option>Vegetariano</option>
                        <option>Dulcerías</option>                       
                      </select>
                    </div>
                   

                    <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="latitude" className="block text-sm font-medium text-gray-700">
                        Localización Latitud
                      </label>
                      <input
                        type="text"
                        name="latitude"
                        id="latitude"
                        value={formik.values.latitude}
                        onChange={formik.handleChange}
                        autoComplete="latitude"
                        className=" h-8 p-4 border mt-1 focus:ring-cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="longitude" className="block text-sm font-medium text-gray-700">
                      Localización Longitud
                      </label>
                      <input
                        type="text"
                        name="longitude"
                        id="longitude"
                        value={formik.values.longitude}
                        onChange={formik.handleChange}
                        autoComplete="longitude"
                        className=" h-8 p-4 border mt-1 focus:ring-cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                    </div> 
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                        Teléfono
                      </label>
                      <input
                        type="text"
                        name="phone"
                        id="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        autoComplete="phone"
                        className="mt-1 focus:ring-cyan-500 focus:border-cyan-500 block border w-full h-8 p-4 shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                    </div>

                    <div className='md:grid md:grid-cols-3 md:gap-6 lg:grid lg:grid-cols-3 lg:gap-6'>
                    <div className="mt-4 space-y-4">
                      <div className="flex items-start">
                        <div className="flex items-center h-5">
                          <input
                            id="clima"
                            name="clima"
                            type="checkbox"
                            className="focus:ring-cyan-500 h-4 w-4 text-cyan-600 border-gray-400 rounded"
                            onChange={formik.handleChange}
                          />
                        </div>
                        <div className="ml-3 text-sm">
                          <label htmlFor="comments" className="font-medium text-gray-700">
                            Clima
                          </label>
                          <p className="text-gray-500">Local climatizado-Reservado.</p>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="flex items-center h-5">
                          <input
                            id="parking"
                            name="parking"
                            type="checkbox"
                            onChange={formik.handleChange}
                            className="focus:ring-cyan-500 h-4 w-4 text-cyan-600 border-gray-400 rounded"
                          />
                        </div>
                        <div className="ml-3 text-sm">
                          <label htmlFor="candidates" className="font-medium text-gray-700">
                            Parqueo
                          </label>
                          <p className="text-gray-500">Área de parqueo.</p>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="flex items-center h-5">
                          <input
                            id="delivery"
                            name="delivery"
                            type="checkbox"
                            onChange={formik.handleChange}
                            className="focus:ring-cyan-500 h-4 w-4 text-cyan-600 border-gray-400 rounded"
                          />
                        </div>
                        <div className="ml-3 text-sm">
                          <label htmlFor="offers" className="font-medium text-gray-700">
                            Entregas
                          </label>
                          <p className="text-gray-500">Servicio de mensajería.</p>
                        </div>
                      </div>
                    </div>
                    </div>


                  <div>
                    <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                     Descripción del Negocio
                    </label>
                    <div className="mt-1">
                      <textarea
                        id="description"
                        name="description"                        
                        onChange={formik.handleChange}
                        rows={3}
                        className="shadow-sm p-4 focus:ring-cyan-500 focus:border-cyan-500 mt-1 block w-full sm:text-sm border border-gray-400 rounded-md"
                        placeholder="De que se trata el negocio, su historia, su misión"
                        defaultValue={''}
                      />
                    </div>
                    </div>

                    <div>
                    <label htmlFor="metadata" className="block text-sm font-medium text-gray-700">
                     Metadata del Negocio
                    </label>
                    <div className="mt-1">
                      <textarea
                        id="metadata"
                        name="metadata"                     
                        onChange={formik.handleChange}
                        rows={3}
                        className="shadow-sm p-4 focus:ring-cyan-500 focus:border-cyan-500 mt-1 block w-full sm:text-sm border border-gray-400 rounded-md"
                        placeholder="De que se trata el negocio, su historia, su misión"
                        defaultValue={''}
                      />
                    </div>
                    </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">Logo</label>
                    <div className="mt-1 flex items-center">
                      <span className="inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100">
                        <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                      </span>
                      <button
                        type="button"
                        className="ml-5 bg-white py-2 px-3 border border-gray-400 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
                      >
                        Cargar
                      </button>
                    </div>
                  </div>



                  <div>
                    <label className="block text-sm font-medium text-gray-700">Galería</label>
                    <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-400 border-dashed rounded-md"
                    {...getRootPropsImages()}
                    >
                       <input {...getInputPropsImages()} />
                      <div className="space-y-1 text-center">
                     
                        <svg
                          className="mx-auto h-12 w-12 text-gray-400"
                          stroke="currentColor"
                          fill="none"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                        >
                          <path
                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <div className="flex text-sm text-gray-600">
                          <label
                            htmlFor="file-upload"
                            className="relative cursor-pointer bg-white rounded-md font-medium text-cyan-600 hover:text-cyan-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-cyan-500"
                          >
                            <span>Cargar un archivo</span>
                            <input id="file-upload" name="file-upload" type="file" className="sr-only" />
                          </label>
                          <p className="pl-1">o arrastrar y soltar</p>
                        </div>
                        <p className="text-xs text-gray-500">PNG, JPG, GIF hasta 10 MB</p>
                      </div>
                    </div>
                  </div>
                </div>

                 <div>
            
                 </div>


                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                  <button
                    type="submit"
                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
                  >
                   Crear Negocio
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

   
      </main>
   </div> 
  )
}
